<template>
    <div class="head">
        <div class="head-inner">
            <div>
                <div>项目需求池</div>
                <p  style="margin-top: 20px;">来这里让你的项目变得更简单</p>
            </div>
          <div style="padding-top: 28px;">
            <img src="../assets/images/headbg.png" alt="" style="">
          </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'projectHead',
}
</script>
<style scoped lang="less">
.head-inner {
    position: relative;
    width: 1400px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    &>div {
      
        font-size: 36px;
        font-family: PingFang;
        font-weight: bold;
        color: #00296C;
        line-height: 30px;

        p {
            font-size: 24px;
            font-family: PingFang;
            font-weight: 500;
            color: #00296C;
            line-height: 30px;
        }
        
    }
}

.head {
    width: 100%;
    background: #DDE5F3;
    height: 300px;
}
</style>